module.exports = __webpack_public_path__ + "static/media/ico-read-more-orange.037b4100.svg";